import { DEFAULT_EMPTY_VALUE } from 'utils/constants';
import {
  getItemOrDefaultToValue,
  getPersonName,
  getPhoneNumber,
} from 'utils/details';
import { displayTime } from 'utils/time';
import { isEmpty } from 'lodash';
import { translatedKeyValueText } from 'utils/methods/helpers';
export const getVisitPurpose = purpose => {
  if (isEmpty(purpose)) return '-';
  if (purpose.description === 'VISIT_PERSON') {
    const value = getPersonName(purpose);
    return translatedKeyValueText('visit_person_by_name', { value });
  }
  return purpose.description;
};

export const getDestination = destination => {
  if (destination.id === '') return '-';
  let type = destination.assetType;
  if (destination.assetTypeID) {
    type = `(${destination.assetTypeID}) ${destination.assetType}`;
  }
  let name = destination.assetName;
  if (destination.assetID) {
    name = `(${destination.assetID}) ${destination.assetName}`;
  }
  return `${name}: ${type}`;
};
export const transformVisitorList = (list, timeZone) => {
  return list.map(data => ({
    id: data.id,
    siteName: getItemOrDefaultToValue(data, 'siteName', DEFAULT_EMPTY_VALUE),
    visitorId: data.visitor.id,
    passName: data.passName || DEFAULT_EMPTY_VALUE,
    name: getPersonName(data.visitor, DEFAULT_EMPTY_VALUE),
    //email: getItemOrDefaultToValue(data.visitor, 'email', DEFAULT_EMPTY_VALUE),
    firstName: data.visitor.firstName,
    lastName: data.visitor.lastName,
    phone: getPhoneNumber(data.visitor.phone, DEFAULT_EMPTY_VALUE),
    type: data.visitor.visitorType
      ? data.visitor.visitorType || DEFAULT_EMPTY_VALUE
      : '-',
    purpose: data.purpose ? getVisitPurpose(data.purpose) : '-',
    destination: data.destination ? getDestination(data.destination) : '-',
    vehicleRegistration: getItemOrDefaultToValue(
      data.visitor,
      'vehicleRegistration',
      '-',
    ),
    visitorCompany: data.visitor
      ? data.visitor.company || DEFAULT_EMPTY_VALUE
      : DEFAULT_EMPTY_VALUE,
    accessTime: data.accessTime
      ? displayTime({ timestamp: data.accessTime, timeZone })
      : DEFAULT_EMPTY_VALUE,
    egressTime: data.egressTime
      ? displayTime({
          timestamp: getItemOrDefaultToValue(data, 'egressTime'),
          timeZone,
        })
      : DEFAULT_EMPTY_VALUE,
    siteId: getItemOrDefaultToValue(data, 'siteId', DEFAULT_EMPTY_VALUE),
    signedInBy: getPersonName(data.signerIn, DEFAULT_EMPTY_VALUE),
    signedOutBy: data.signerOut
      ? getPersonName(data.signerOut, DEFAULT_EMPTY_VALUE)
      : DEFAULT_EMPTY_VALUE,
  }));
};
